import { render } from "./bill_edit.vue?vue&type=template&id=9f276976"
import script from "./bill_edit.vue?vue&type=script&lang=js"
export * from "./bill_edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/igor.boldin/projects/edit/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QToggle,QSeparator,QOptionGroup,QBtn});
